import React from 'react';
import Hero from '../components/Hero';
import TrustedBy from '../components/TrustedBy';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Pricing from '../components/Pricing';
import SuccessStories from '../components/SuccessStories';
import Team from '../components/Team';
import CTA from '../components/CTA';

const Home = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Hero />
      <TrustedBy />
      <Features />
      <HowItWorks />
      <Pricing />
      <SuccessStories />
      <Team />
      <CTA />
    </div>
  );
};

export default Home;
